var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    staticClass: "OfferIcon",
    attrs: { title: _vm.picto.name, "aria-label": _vm.picto.name },
    domProps: { innerHTML: _vm._s(_vm.picto.svg) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }